import { ReadAgreementDetail } from "@/schemas/agreement";
import { useAgreementContext } from "../context";

export const useAgreementData = (): ReadAgreementDetail => {
  const { data, loadingState, errorState } = useAgreementContext();

  if (loadingState.isLoading) {
    throw new Error("Agreement data is still loading");
  }
  if (errorState.error) {
    throw errorState.error;
  }
  if (!data) {
    throw new Error("No agreement data available");
  }

  return data;
};
